module.exports = __webpack_public_path__ + "img/code-slash.441cec98.svg";